import React, { useState } from "react";
import './Media.css';
import Footer from './Footer';
import EmbeddedContent from "./EmbeddedContent";
import Gallery from "./Gallery";

// Define your media items here
const mediaData = {
  'shoot1': {
    title: 'WELCOME TO THE SLEEPOVER',
    date:  'September 2022',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505652/COVER_zmi5re.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505663/046FC060-ED89-4702-8268-3686E640E113_aapuhu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505663/87944D31-6BE3-476C-A952-9BEC42B856CD_bcp7lb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505663/E85112E0-5C8E-402F-BBAC-9872AC22690E_kfv1gx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505663/IMG_7574_ifyeh8.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505662/AC62597D-D4EF-4C89-8825-9852AB5AECDF_oy7hcu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505661/IMG_7661_hpjidr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505661/IMG_7642_x8kaul.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505661/05C57DFE-98CA-4781-BE92-B780046BAB6C_cnv9jf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505660/IMG_7689_xbirfs.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505660/19E6733B-ED6D-4F28-A536-8C9666B27B4D_qzczre.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505660/358D543A-7CEC-44D4-91E1-16863199C772_c60nkj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505659/60AE266D-F628-4B6C-A796-CA02597734A6_l5s5aq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505659/E7C79B10-E699-471C-A4F4-F7F1C77E75FA_fnfwmr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505658/CE1E7658-6CD0-499A-A306-ED89886F3C30_jgh5ex.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505658/4CD7F61D-F04A-40C7-89D1-2FA7D09E580B_ba5o2i.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505657/3FE3C207-B5CB-436C-B81A-E4FFA6FB8456_i8qqrv.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505657/328012CA-7932-457B-9B7B-FD17BD3D671C_ee8iuq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505657/IMG_7788_hqoiyu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505657/228B90E4-7E77-4FB8-A5E1-84ADFAE851C3_muts1m.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505656/IMG_7938_r9arap.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505655/E41AA9A0-C37A-4D95-B9CB-9DBE306559D0_r7jtsu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505655/BC518969-1869-4037-9566-69900208C940_xrxvob.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505655/887C6708-15E5-4D2D-A5C8-1841738F6FAA_feqoon.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505655/IMG_7991_uoju70.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505655/IMG_8006_c58neu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505654/8C1F71E0-A980-4E7D-A303-47D2068EA44E_j1vyll.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505654/2F6C567F-0C00-4E33-8ABA-C6F767D44C00_ieeets.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505653/IMG_7997_yhpwkt.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505653/IMG_8075_bh1bsj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749505653/COVER_PHOTO_xtck6z.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749505652/COVER_zmi5re.jpg',
    issue: '14',
  },
  'shoot2': {
    title: 'UPTOWN GIRL',
    date: 'February 2022',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506099/COVER_mztuzx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506106/IMG_6749_iu469b.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506102/IMG_6800_wsfhvk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506100/IMG_6791_ys3xlu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506101/IMG_6803_cvyvhr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506100/IMG_6788_lvmdw5.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506099/IMG_6793_rb74ig.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506098/IMG_6733_pkmb6z.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506097/IMG_6764_xrhevs.jpg'
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749506099/COVER_mztuzx.jpg',
    issue: '11',
  },

  'shoot3': {
    title: 'UPPER EAST SIDE’S RUNAWAY BRIDE',
    date: 'October 2023',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749506626/COVER_edab7z.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507156/IMG_5651_vfwk2z.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507155/IMG_5707_wvy375.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507153/IMG_5670_pqrzbl.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507152/IMG_5718_usnkv7.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507151/IMG_5643_d1h1sn.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507150/IMG_5546_uxoylt.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507149/IMG_5550_fnjrlw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507148/IMG_5554_md7p04.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507147/IMG_5562_eqv06o.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507146/IMG_5563_dat4uo.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507145/IMG_5571_hm7vmg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507144/IMG_5586_g9hecm.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507142/IMG_5595_zxy275.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507142/IMG_5599_gqrrqe.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507140/IMG_5609_fdciyb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507139/IMG_3594_neyjev.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507139/IMG_5474_lykpfm.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749507138/IMG_5535_au1lb0.jpg',
      'https://res.cloudinary.com/dltjxocio/video/upload/v1749506477/final_main_centered_text_video_cdw76r.mp4',
      'https://res.cloudinary.com/dltjxocio/video/upload/v1749506476/final_photo_centered_vcpjrp.mp4',
      
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749506626/COVER_edab7z.jpg',
    issue: '19',
  },
    'shoot4': {
    title: 'TUNE INTO REHEARSAL',
    date: 'April 2023',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517702/COVER_j1nlj5.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517711/IMG_4399_cjvfzc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517703/IMG_4378_bzs3hl.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517708/IMG_4423_tp2rdi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517707/IMG_4419_f87xuq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517706/IMG_4414_krn7n4.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517706/IMG_4410_axm1hc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517705/IMG_4404_jov0pq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517704/IMG_4392_vfzo85.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517704/IMG_4389_vtnht7.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517703/IMG_4363_gcpiou.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517702/IMG_4433_mcgfkq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517702/IMG_4401_ozftxd.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517701/IMG_4395_a9osjh.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749517702/COVER_j1nlj5.jpg',
    issue: '17',
  },

    'shoot5': {
    title: 'THE GRASS IS GREENER',
    date: 'March 2021',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518015/IMG_6645_pkddod.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518012/IMG_6735_c3ygk3.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517985/IMG_6731_m3b4z4.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517984/IMG_6755_axt3qa.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517984/IMG_6743_se7nzb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517983/IMG_6785_xrbakg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517982/IMG_6778_hg8j8c.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749517982/IMG_6832_1_zpa22s.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749518015/COVER_PHOTO_movim5.jpg',
    issue: '1',
  },

  'shoot6': {
    title: 'THE DISCO DEN',
    date: 'July 2024',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518418/COVER_yjsypc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518420/COVER_PHOTO_r6wmq1.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518432/IMG_5320-Enhanced-NR_mtmmjn.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518431/IMG_5216-Enhanced-NR_qyurai.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518431/IMG_5244-Enhanced-NR_xs7ugt.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518429/IMG_5178-Enhanced-NR_d1imtj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518428/IMG_5571-Enhanced-NR_k5jmub.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518427/IMG_5518-Enhanced-NR_nuyxre.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518427/IMG_5459-Enhanced-NR_hcummd.jpg',
      'https://res.cloudinary.com/dltjxocio/video/upload/v1749518421/sep_10_longer_text_mh8s1b.mp4',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518421/IMG_5444-Enhanced-NR_xevwip.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518416/foramrutha1new_eaprqi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518415/foramrutha2new_sjji0a.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518414/foramrutha5_qla0sy.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518413/foramrutha7_yjxmpc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518412/foramrutha8_lcjnuw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518411/foramrutha9_t3dlrk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518410/foramrutha10_deiuqj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518409/foramrutha12_l39wcd.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518358/foramrutha13_rlp7kl.jpg',
      'https://res.cloudinary.com/dltjxocio/video/upload/v1749518357/FIRST_rwppni.mp4',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518357/foramrutha14_thisoneiquestion_nikwua.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749518356/greenbohemiantest2_zzn2na.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749518420/COVER_PHOTO_r6wmq1.jpg',
    issue: '22',
  },

  'shoot7': {
    title: 'THE BAY AREA COLLECTIVE',
    date: 'December 2024',
    description: '',
    images: [
      '../Assets/Large-Content/COVER-PHOTO.jpg',
      'https://res.cloudinary.com/dltjxocio/video/upload/v1749519382/FIRST_3_fvvupl.mp4',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519412/_DSC0293-Enhanced-NR_bpmkbg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519385/_DSC0149-Enhanced-NR_nnzekj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519395/_DSC0567-Enhanced-NR_tz0uch.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519399/_DSC0624-Enhanced-NR_ki0byl.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519390/_DSC0849-Enhanced-NR_fkabs3.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519403/_DSC0458-Enhanced-NR_lk4xxc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519418/_DSC0069-Enhanced-NR_ywdyuz.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519397/_DSC0632-Enhanced-NR_graady.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519411/_DSC0309-Enhanced-NR_qnjbsd.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519407/_DSC0302-Enhanced-NR_kngugf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519396/_DSC0594-Enhanced-NR-2_xaghoo.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519386/_DSC0985-Enhanced-NR_rutxoh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519389/_DSC0655-Enhanced-NR_fsqh9x.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519416/_DSC0072-Enhanced-NR-2_nb2exy.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519396/_DSC0670-Enhanced-NR_gz8nbl.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749519395/_DSC0582-Enhanced-NR_mhy72v.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520031/_DSC0021-Enhanced-NR_u2aoto.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520036/_DSC0031-Enhanced-NR_tgd8ob.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520030/_DSC0223-Enhanced-NR_gu2gqq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520025/_DSC0241-Enhanced-NR_wdbszg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520035/_DSC0500-Enhanced-NR_xs0xy6.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520024/IMG_3453_for3s2.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520016/_DSC0534-Enhanced-NR_sisgi0.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520022/_DSC0999-Enhanced-NR_mmgi5u.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520033/_DSC0392-Enhanced-NR_oj9619.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520021/_DSC0872-Enhanced-NR_mppwri.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520028/_DSC0278-Enhanced-NR_ffsfnr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520018/_DSC0535-Enhanced-NR_hssrxr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520015/_DSC0350-Enhanced-NR_ovwgh9.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520027/_DSC0206-Enhanced-NR_g9pajs.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520014/_DSC0286-Enhanced-NR_c5apt7.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749520019/_DSC0555-Enhanced-NR_izcg62.jpg',
      '../Assets/Large-Content/video1.mp4',
      '../Assets/Large-Content/video2.mp4',  
    ],
    thumbnail: '../Assets/Large-Content/COVER-PHOTO.jpg',
    issue: '24',
  },

  'shoot8': {
    title: 'THE AFTER PARTY',
    date: 'March 2024',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522287/COVER_hsrung.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522291/IMG_0895_d5j4jo.jpg',
      '../Assets/Large-Content/video3.mp4',
      '../Assets/Large-Content/video4.mp4',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522291/IMG_0546_rw6lqs.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522290/IMG_0919_hly8e8.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522289/IMG_0300_crpudc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522289/IMG_0673_wpdvxo.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522288/IMG_0294_mfytdv.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522287/IMG_1002_w0wb6x.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522286/IMG_0973_wdqsxz.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522285/IMG_0897_idzurp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522285/IMG_0730_o2dlzs.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522285/IMG_0792_aldahz.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522284/IMG_0722_vbruzp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522284/IMG_0644_slxl4e.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522283/IMG_0595_ukninu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522283/IMG_0578_edbcu1.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522282/IMG_0537_wb6tzq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522282/IMG_0567_mbv5fi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522280/IMG_0336_l7auoe.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522282/IMG_0523_bbtola.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522281/IMG_0386_fpz1aw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522281/IMG_0479_qsbclp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522280/IMG_0341_dctud7.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522280/IMG_0325_q7gxee.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522279/afterthepartystill5_tozjcy.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522279/afterthepartystill4_g3phon.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522278/afterthepartystill3_sqkgf9.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522278/afterthepartystill2_k7im2h.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749522278/afterthepartystill1_wpocsa.jpg',

    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749522287/COVER_hsrung.jpg',
    issue: '20',
  },

  'shoot9': {
    title: 'SWINGING IN STYLE',
    date: 'July 2024',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523460/COVER_hsowqh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523469/IMG_5666_ln6qre.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523467/IMG_5545_diusij.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523466/IMG_5665_emza6b.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523464/IMG_5658_pupm4t.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523463/IMG_5634_ci17gd.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523462/IMG_5509_mgrz89.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523461/IMG_5607_as8pux.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523460/COVER_hsowqh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523458/IMG_5621_ilp8gn.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523457/IMG_5547_q7ixl3.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523456/IMG_5540_zpd0hz.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523455/IMG_5519_tctt5k.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523453/IMG_5516_mdfrfo.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523452/IMG_3954_njyjha.jpg',
      '../Assets/Large-Content/video5.mp4',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749523460/COVER_hsowqh.jpg',
    issue: '22',
  },

  'shoot10': {
    title: 'SUMMER SOIRÉE',
    date: 'July 2022',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523993/COVER_xzhk1d.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523995/IMG_8886_sbfn7d.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523995/IMG_8959_uyukhx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749523997/IMG_8966_sygq3m.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524000/IMG_9074_rxpuyr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524001/IMG_9089_iy6pzi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524003/IMG_9117_z4yyi7.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524033/IMG_8945_ckkxss.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524036/IMG_9018_qdjzus.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749523993/COVER_xzhk1d.jpg',
    issue: '13',
  },

  'shoot11': {
    title: 'STAY IN MOTION',
    date: 'December 2024',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524232/3X1A6777_rvombr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524230/3X1A6828_rxgclr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524228/3X1A6739_s8xnpx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524227/3X1A6738_k0vnev.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524227/3X1A6706_tmffwp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524224/3X1A6787_ahazip.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524222/3X1A6775_nplqgh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524220/3X1A6812_lmkawe.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524218/3X1A6736_umzl2f.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524216/3X1A6770_qb3mev.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524214/3X1A6788_uupvpb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524213/3X1A6760_oovfnz.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524211/3X1A6708_h2gmhv.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524209/3X1A6798_yx0hyh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524207/3X1A6729_gidfdm.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524206/3X1A6764_w3oa7l.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524204/3X1A6779_xnoxpj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524202/COVER_PHOTO_azqbjg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749524200/COVER_qkjluj.jpg',
      '../Assets/Large-Content/video6.mp4',
      '../Assets/Large-Content/video7.mp4',
      '../Assets/Large-Content/video8.mp4',
      'https://res.cloudinary.com/dltjxocio/video/upload/v1749524201/FIRST_4_gz8run.mp4',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749524202/COVER_PHOTO_azqbjg.jpg',
    issue: '24',
  },

  'shoot12': {
    title: 'SPOTTED!',
    date: 'October 2023',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525369/COVER_brnavc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525375/IMG_5207_avmxa1.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525373/IMG_5199_m3fbmv.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525370/IMG_5178_ahffct.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525366/IMG_5155_zkjv5s.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525364/IMG_5124_htag7l.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525362/IMG_5117_qmuotj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525360/IMG_5309_mol6ls.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525358/IMG_5227_cwcoru.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525356/IMG_5102_bobbwx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525354/IMG_5094_ai7nil.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525352/IMG_5083_zad8oe.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525350/IMG_5075_nqfbzb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525348/IMG_5093_ktt4te.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525345/IMG_5091_rzufzi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525344/IMG_5077_jh5qml.jpg',
      '../Assets/Large-Content/video9.mp4',
      '../Assets/Large-Content/video10.mp4'
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749525369/COVER_brnavc.jpg',
    issue: '19',
  },

  'shoot13': {
    title: 'SOFT TIES & SUNNY SKIES',
    date: 'March 2021',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525828/COVER_w9zoeo.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525838/IMG_9992_1_wsabor.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525835/IMG_9946_1_bxfnt9.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525832/IMG_3595_txztgr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525830/E0AC2112-548C-414D-958D-7EEA4411FE10_wv5aoi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525825/C26302BF-6291-4230-849E-93FB8459F969_kqin7y.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525823/B08FA03E-59A2-4739-A0DA-599D39CDC060-B5EEC6FC-CF15-46F3-B2C7-94683694F0AC_c4s1jh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525820/5A10C968-7E8A-4F11-AA53-980DF5DC40B8_ywxuy1.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525819/2DF143DA-B4AC-45FE-AED9-F7E38358B013_mqnvdw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749525817/1EAE68D9-FE9B-4EAB-AC32-32A54C854220-CF7C6AF6-21ED-4259-A421-BDD4156C92C8_gfx9ym.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749525828/COVER_w9zoeo.jpg',
    issue: '1',
  },

  'shoot14': {
    title: ' SARI UNDER THE SEA',
    date: 'October 2024',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526077/COVER_kvwgdy.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526087/DSC_0339_vlhgsk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526092/IMG_5962_y2xoja.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526092/DSC_0399_ixrujf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526096/IMG_6000_ab4qos.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526099/IMG_5925_qdwkcr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526101/IMG_5968_vdvrtw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526211/IMG_5991_rrerbk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526217/IMG_5995_zo0zzm.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526217/DSC_0332_dwocpa.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526221/DSC_0631_x2936r.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526228/IMG_5933_xhyvlw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526231/IMG_5897_d59ny0.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526239/IMG_5928_fpdas8.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526244/DSC_0482_cnyeew.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526248/DSC_0614_ov9dyp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526254/DSC_0479_my1flx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526263/DSC_0396_peuykq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526266/IMG_5942_xrh4om.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526415/DSC_0509_fviwbj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526418/DSC_0596_bwjjpj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526420/DSC_0797_jxkww1.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526431/DSC_0769_lus3gw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526434/DSC_0749_ov73nf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526437/IMG_3953_kodqai.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526440/DSC_0746_ifypeb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526442/DSC_0715_jzcyd2.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526446/DSC_0713_ldhach.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526450/DSC_0711_mni6qf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526452/DSC_0823_qcat9p.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526456/DSC_0805_fnpsyv.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526458/DSC_0697_os1mma.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526461/DSC_0680_atywth.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526464/IMG_3954_bnapj0.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526467/DSC_0550_uro7pk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526470/DSC_0663_ipsm9c.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526472/DSC_0692_weiizq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526475/DSC_0885_t3ylhc.jpg',
      '../Assets/Large-Content/video11.mp4',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749526077/COVER_kvwgdy.jpg',
    issue: '23',
  },

  'shoot15': {
    title: 'PURPLE REIGN',
    date: 'September 2021',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526820/COVER_hqdahu.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526839/IMG_4039_n36tym.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526850/IMG_4128_jz9nys.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526851/IMG_4136_zp1qph.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526852/IMG_4088_puec6c.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526852/IMG_4085_ni5og1.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526852/IMG_4126_h8jnpi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749526853/Done_lt4s4y.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749526820/COVER_hqdahu.jpg',
    issue: '7',
  },

  'shoot16': {
    title: 'PROM KING & QUEEN',
    date: 'November 2022',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527272/COVER_vkrspq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527276/IMG_4372_ceq9sf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527275/IMG_4376_pyaccb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527274/IMG_4388_poqw3w.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527273/IMG_4393_qepdrc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527272/IMG_4397_bea6ap.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527272/COVER_vkrspq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527271/IMG_4368_s2jezh.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527271/IMG_4363_fvaugg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527270/IMG_4371_kvnrat.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527269/IMG_4390_l8kiav.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527051/IMG_4432_tqn8gl.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527051/IMG_4446_uqoklb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527051/IMG_4416_mpnjo5.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527050/IMG_4401_inifmq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527050/IMG_4407_bhriao.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527046/IMG_4389_dpjx0u.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527045/IMG_4385_geoq6a.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527045/IMG_4379_xaz35q.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527040/IMG_4359_h1o8xa.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749527272/COVER_vkrspq.jpg',
    issue: '15',
  },

  'shoot17': {
    title: 'PROJECTED BEAUTY',
    date: 'January 2022',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527626/COVER_bac14z.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527666/IMG_0043_ip8ild.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527664/IMG_0185_lr6d0y.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527663/IMG_0298_bwvuwy.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527662/IMG_0279_by8ree.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527661/IMG_0228_vxo20m.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527660/IMG_0333_arkhbf.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527659/IMG_3087_tsmjsa.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527629/IMG_3140_gpqyrj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527629/IMG_3142_j7k37h.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527627/IMG_3288_xv1sdp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527626/IMG_3141_xgk5hg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749527625/IMG_2943_jjye20.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749527626/COVER_bac14z.jpg',
    issue: '10',
  },

  'shoot18': {
    title: 'POOLSIDE BARBIES',
    date: 'July 2023',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529816/COVER_gawlae.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529807/IMG_2461_cvo0r6.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529808/IMG_2463_fcmmto.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529810/IMG_2466_a00izb.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529810/IMG_2467_rj6xrt.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529812/IMG_2469_vgu7ki.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529814/IMG_2591_jhpisz.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529815/IMG_2473_usy0uq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529817/IMG_2528_iiwkpk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529819/IMG_2538_istang.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529821/IMG_2481_ejqhhm.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529822/IMG_2559_aznkat.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529823/IMG_2565_rzkbat.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529825/IMG_2579_wb3mza.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529827/IMG_2493_dwzdl9.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529828/IMG_2581_umbtcx.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529938/IMG_2593_ypicwy.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529938/IMG_2594_zpu5db.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529940/IMG_2596_lllxnp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529942/IMG_2601_nuryql.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529943/IMG_2605_um88ek.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529945/IMG_2607_rkdhq2.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529946/IMG_2610_q86t8d.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529949/IMG_2602_jkxctg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529950/IMG_2608_t80ovq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749529952/IMG_4959_oxvxm8.jpg',
      '../Assets/Large-Content/video12.MP4',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749529816/COVER_gawlae.jpg',
    issue: '18',
  },

  'shoot19': {
    title: 'PRETTY GIRLS LIKE TRAP MUSIC',
    date: 'February 2023',
    description: '',
    images: [
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530658/COVER_rwlccc.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530659/IMG_7487_yvjjor.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530662/IMG_7605_vsb0hi.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530663/IMG_7326_j82uw2.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530663/IMG_7328_w8ajab.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530663/IMG_7615_hxl1wp.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530667/IMG_7717_l4urqg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530668/IMG_7492_r3dc1k.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530668/IMG_7401_en29kw.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530668/IMG_7631_nsl8cl.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530672/IMG_7595_g61ctq.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530672/IMG_7445_zsmitr.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530674/IMG_7358_bvytb0.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530676/IMG_7656_snr1yj.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530676/IMG_7410_c4t8yd.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530676/IMG_7620_qa7onk.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530677/IMG_7320_eavuri.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530678/IMG_7311_l2oig9.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530929/IMG_4535_znmhao.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530929/IMG_7382_sdm0ts.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530931/IMG_7425_agsvzg.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530931/IMG_7494_cafvts.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530932/IMG_7511_lg0gda.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530932/IMG_7498_cl8cba.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530933/IMG_7522_okwqq5.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530933/IMG_7527_cfhbce.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530934/IMG_7536_b6izch.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530935/IMG_7703_af82po.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530935/IMG_7721_qt5jp0.jpg',
      'https://res.cloudinary.com/dltjxocio/image/upload/v1749530937/IMG_7722_wrw95j.jpg',
    ],
    thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749530658/COVER_rwlccc.jpg',
    issue: '16',
  },

  'shoot20': {
  title: 'OOPS!...SHE DID IT AGAIN',
  date: 'January 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532059/COVER_uns9wh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532059/IMG_0033_vo79pg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532060/IMG_0059_gq1ynn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532060/IMG_0040_ylfig8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532061/IMG_0092_ez2dpa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532061/IMG_0105_udvs4c.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532062/IMG_0125_thlykw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532062/IMG_0152_bt1vub.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532064/IMG_0156_hknujn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532065/IMG_0211_tibrji.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532065/IMG_0135_w3wbyh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532066/IMG_0184_y829as.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532066/IMG_0212_taosq2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532068/IMG_9801_f8zcsp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532069/IMG_9802_qaoe5w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532069/IMG_0219_vq473a.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532071/IMG_9866_amhvaw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532070/IMG_0261_nnapce.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532072/IMG_9873_oc8snz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532072/IMG_9915_agczvk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532073/IMG_9877_d3x7k8.jpg',
    '../Assets/Large-Content/video13.mp4',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749532059/COVER_uns9wh.jpg',
  issue: '20',
},

  'shoot21': {
  title: 'ONCE UPON A MEHENDI',
  date: 'October 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532474/COVER_qlwkh1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532524/DSC_2236_gio5jk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532514/DSC_2485_pyopbw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532518/DSC_2183_p2vor4.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532508/DSC_2520_mkgimc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532477/..._jybjqo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532521/DSC_2278_v65mfs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532516/DSC_2228_xzi2hc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532508/DSC_2561_re9aaq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532467/DSC_1877_l2jnjo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532514/DSC_2526_cuo3xn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532472/DSC_1844_k8tw5h.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532516/DSC_1958_tvvmt6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532465/DSC_2305_qtf3tk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532506/DSC_2218_ncmqmq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532465/DSC_2305_qtf3tk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532506/DSC_2218_ncmqmq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532525/DSC_1892_holj9t.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532466/DSC_2291_icp1tb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532469/DSC_1832_d7pvqg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532520/DSC_2529_dnsbde.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532512/DSC_2049_rie17p.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532520/DSC_1963_jydcmi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532522/DSC_2104_yqrisv.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532525/DSC_1923_f1akrs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532467/DSC_1858_dlfeau.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532526/DSC_2047_um4mmm.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532512/DSC_1884_r1ednj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532456/DSC_1946_gipojw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532469/DSC_1825_opzb1b.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532509/DSC_1928_fjwg28.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532508/DSC_2051_x5uuzp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532469/DSC_1847_qcn4wo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532518/DSC_1972_g0k3zp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532496/_DSC0478_s2pstg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532502/_DSC0100_d22pj2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532476/_DSC0803-Enhanced-NR_rodanj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532491/_DSC0801-Enhanced-NR_hooqug.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532492/_DSC0793-Enhanced-NR_f1yv5o.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532495/_DSC0414_ayuqr2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532488/_DSC0752-Enhanced-NR_cng2pd.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532460/_DSC0230-2_sstkci.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532472/_DSC0387_jngp4p.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532487/_DSC0455-Enhanced-NR_vfardk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532478/_DSC0490-Enhanced-NR_nztanw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532470/IMG_3434_pymcoe.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532503/_DSC0115_fhiedu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532499/_DSC0079_ngq7fa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532481/_DSC0211_jgjcrn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532482/_DSC0518-Enhanced-NR_xprq6h.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532458/_DSC0266_gktgyl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532501/_DSC0169_lt8san.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532477/_DSC0202_zwkgvx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532497/_DSC0319_a0iutk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532484/_DSC0212_oaf8p3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532498/_DSC0533-Enhanced-NR_mtyivj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532477/_DSC0318_pp61fw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532462/_DSC0225_egbfqz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532490/_DSC0628-Enhanced-NR_zv3r5w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532485/_DSC0542-Enhanced-NR_yjkqfp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532458/_DSC0240_b2cult.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532455/COVER_PHOTO_bq3apz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532501/_DSC0171_ezmaqt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532493/_DSC0564-Enhanced-NR_ghdpo0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532459/_DSC0245_muglcy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532496/_DSC0650-Enhanced-NR_sg4txg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532456/IMG_3334_spbxfn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532481/_DSC0307_p6shbt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532479/_DSC0697-Enhanced-NR_jibnoz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749532452/IMG_2951_k796vn.jpg',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749532453/FIRST_1_gymnhe.mp4',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749532474/COVER_qlwkh1.jpg',
  issue: '23',
},

  'shoot22': {
  title: 'ON COURT',
  date: 'March 2022',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533329/COVER_fxqqkb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533363/IMG_7443_yqk7vn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533365/IMG_7372_tlqbgu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533366/IMG_7370_fk1ixr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533370/IMG_7363_gx5hdi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533490/IMG_7407_fzezjs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533492/IMG_7439_qksaos.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533493/IMG_7441_desm7e.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533494/IMG_7512_gubsyu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533495/IMG_7521_wlxpjs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533496/IMG_7523_r91qsx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533497/IMG_7606_vbrloa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533499/IMG_7619_ztgu0v.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533500/IMG_7664_mjjlli.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533501/IMG_7631_xik2of.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749533329/COVER_fxqqkb.jpg',
  issue: '12',
},

'shoot23': {
  title: 'NO PAPARAZZI',
  date: 'February 2023',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533725/COVER_t5dt60.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533732/IMG_7156_qdqvhu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533730/IMG_7192_qfwumf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533729/IMG_7107_qx03fa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533728/IMG_7096_l5ohkg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533726/IMG_7004_fybt4t.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533723/IMG_7217_qeathw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533722/IMG_7216_gxuypd.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749533725/COVER_t5dt60.jpg',
  issue: '16',
},

'shoot24': {
  title: 'NIGHTTIME RENDEZVOUS',
  date: 'July 2022',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533968/COVER_eapcmk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533970/IMG_9134_yreeub.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533972/IMG_9145_ftw06s.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533973/IMG_9156_rbc1is.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533975/IMG_9160_ps9q8u.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749533977/IMG_9188_kwmp0t.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749533968/COVER_eapcmk.jpg',
  issue: '13',
},

'shoot25': {
  title: 'NAVARATRI LIGHTS',
  date: 'October 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534126/COVER_PHOTO_1_cwdghq.jpg',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749534126/0609_1_x8hdyf.mp4',
    '../Assets/Large-Content/video14.mp4',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534127/_DSC0389-Enhanced-NR_jk2xlk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534132/_DSC0280-Enhanced-NR-2_ekregp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534176/_DSC0369-Enhanced-NR-2_klm0kg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534177/_DSC0199-Enhanced-NR_aopqej.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534180/_DSC0217_orzotp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534180/805137D5-802F-4870-A451-92DDA34E7E2E_ycmgnz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534182/15516018-B4D1-42A4-87DE-B8C5EC82AE47_j6xg0h.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534184/COVER_cjgiul.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534186/COVER_PHOTO_vxwqis.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534187/..._p352hj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534190/_DSC0351-Enhanced-NR_ghw57x.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534192/_DSC0336_t2h8b8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534193/_DSC0271_hhjv7l.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534197/_DSC0325-Enhanced-NR_bbnm6h.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534198/_DSC0296-Enhanced-NR_iormeg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534199/_DSC0341-Enhanced-NR_xsxkjf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534201/_DSC0295-Enhanced-NR_c8wbos.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534203/_DSC0240-Enhanced-NR_zavrnj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534205/_DSC0062_sf5jtj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534207/_DSC0102_wymsvl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534209/0T2A5267_hacpqe.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534210/65FCA2D6-B02D-4414-99FA-6D5304A0C798_cktob3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534212/0T2A5446_erefer.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534214/0T2A5283_fdqipe.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534216/6049902F-08C6-4A43-83D3-8449313CB239_ndof61.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534218/34A111FA-8E2B-4BD1-B926-F73539DA5055_lneybm.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534220/5950EA69-1AB3-43A8-9B51-F5A3BDF17EB2_d9pld6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534221/0T2A5569_ro40wd.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534224/08A7A6F7-B781-4926-B86D-922BF4603F64_uxfaxo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534227/773529C6-CBEA-4185-BFE5-FE85D1750322_ibh17t.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534227/0T2A5498_njzjwp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534230/0T2A5469_eaxpwn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749534232/51E635A0-BDBB-4CFB-9025-1CAB5014D467_kxxvkz.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749534126/COVER_PHOTO_1_cwdghq.jpg',
  issue: '23',
},

'shoot26': {
  title: 'MONSOON MEMORIES',
  date: 'April 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536880/COVER_ij0k5n.jpg',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749536879/FIRST_1_phpd5e.mp4',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536898/IMG_4732_pxnaud.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536896/IMG_4737_wzep6m.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536896/IMG_4735_rwwwgi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536896/IMG_4749_mntlrp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536894/IMG_4772_bb0trf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536894/IMG_4758_moc2br.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536893/IMG_4797_srthuf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536891/IMG_4799_bfpw9j.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536891/IMG_4835_bajhax.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536889/IMG_4838_zvmkqp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536886/IMG_0829_n4qfec.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536885/IMG_0830_vz3sgy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536884/IMG_4723_jvcjsq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536883/IMG_4816_g7ty3p.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536882/IMG_4832_zurstl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536881/IMG_4847_xlfckw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536880/COVER_ij0k5n.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749536877/newrainstill4_w22rtk.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749536880/COVER_ij0k5n.jpg',
  issue: '21',
},

'shoot27': {
  title: 'MASKED GLAMOUR',
  date: 'October 2023',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537696/COVER_o6rwh5.jpg',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749537249/FIRST_1_cljliw.mp4',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749537250/FIRST_2_osrp8v.mp4',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749537251/FIRST_3_u3wcrj.mp4',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537720/IMG_5735_rcefo0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537721/IMG_5747_dj29dh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537722/IMG_5749_wpx1el.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537724/IMG_5756_phluvn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537725/IMG_5761_bpw108.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537726/IMG_5776_wejaej.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537728/IMG_5786_jidz1e.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537729/IMG_5790_bjlxnt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537730/IMG_5798_lvi9fl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537731/IMG_5808_xebaex.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537733/IMG_5811_x3tytm.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537735/IMG_5830_nkctdo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537735/IMG_5853_bnijfk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537736/IMG_5868_o7mqbq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749537738/IMG_5875_djnfyo.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749537696/COVER_o6rwh5.jpg',
  issue: '19',
},

'shoot28': {
  title: 'MADNESS OF MADNESS',
  date: 'October 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538159/COVER_lbkosa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538160/IMG_5744_cvjlpq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538163/IMG_5781_kuuuai.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538163/IMG_2020_b4gmjb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538164/IMG_5803_cqlqdo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538166/IMG_5532_j71d7v.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538167/IMG_5572_ws64aq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538169/IMG_5634_mjzs3j.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538170/IMG_5635_eh7cd1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538172/IMG_5869_dfuyot.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538174/IMG_5647_kboazd.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538175/IMG_5661_anli75.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538177/IMG_5672_xidsxh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538178/IMG_5835_bchdly.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538180/IMG_5874_kthwen.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538181/IMG_5920_sfkalp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538183/IMG_5921_t861f2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538185/IMG_5960_awovvs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538187/IMG_5962_sjjhai.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749538159/COVER_lbkosa.jpg',
  issue: '18',
},

'shoot29': {
  title: 'IN OFFICE',
  date: 'Winter 2025',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538413/COVER_zsutxb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538416/COVER_atrhzf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538423/_DSF2442_1_omtatf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538425/_DSF2376_1_lfa2ai.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538427/_DSF2422_1_bdoit0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538428/_DSF2330_1_s7vbuh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538430/_DSF1972_jqsqsn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538432/_DSF2134_3_nswili.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538434/_DSF1392_gveuxq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538436/_DSF1522_nfjy6w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538437/_DSF1548_uul7gn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538439/_DSF1573_cbmwhx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538441/_DSF1598_krx8vr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538445/_DSF1620_fzqrry.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538446/_DSF1636_pz9bdu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538448/_DSF1691_ythtfq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538451/_DSF1723_ratmww.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538453/_DSF1725_vpy214.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538454/_DSF1746_ajcu2y.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538457/_DSF1794_iil5b9.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538459/_DSF1964_vtoe4w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538461/_DSF2288_reixmc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538462/_DSF2380_t8woad.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538464/_DSF2409_x8pgaj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538466/_DSF2471_c3zs8q.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538468/_DSF2460_eo8iee.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538470/_DSF2497_aqpl3a.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749538413/COVER_zsutxb.jpg',
  issue: '25',
},


'shoot30': {
  title: 'GRAFFITI GROOVE',
  date: 'May 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538699/COVER_dem8tl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538701/IMG_1836_vwrgjn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538703/IMG_1694_zapss8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538705/IMG_1719_qf034t.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538707/IMG_1685_peo1y9.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538710/IMG_1593_a6wwod.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538712/IMG_1565_esx8qz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538714/IMG_1536_rrnliz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538716/IMG_1512_hoigqx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538718/IMG_1534_rz3sef.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538720/IMG_1482_env1wk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538722/IMG_1553_zu3z71.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538724/IMG_1459_vdgbbo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538726/IMG_1455_lgixo0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749538728/IMG_0029_hpv1e8.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749538699/COVER_dem8tl.jpg',
  issue: '3',
},

'shoot31': {
  title: 'GAME ON',
  date: 'August 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541131/COVER_hpqmhs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541132/IMG_2823_fio7ha.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541133/IMG_2599_epmqu8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541135/IMG_2646_xjqe8u.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541137/IMG_2933_rgikry.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541137/IMG_2912_qxombv.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541138/IMG_2718_xlnpfp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541139/IMG_2833_sac3te.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541141/IMG_2893_r5ehix.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541141/IMG_2746_djmwqz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541142/IMG_2812_n1c1kc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541144/IMG_2653_yusmc2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541145/IMG_2706_qgz2el.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541145/IMG_2814_koxiqi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541147/IMG_2921_mfhz5r.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541148/IMG_2594_mx621e.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541149/IMG_2615_m0y2it.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749541131/COVER_hpqmhs.jpg',
  issue: '6',
},


'shoot32': {
  title: 'FRESH OFF THE STREET',
  date: 'July 2023',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540832/COVER_urynqk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540834/IMG_5916_suyxai.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540837/IMG_5929_kpiit3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540842/IMG_5933_z21je8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540842/IMG_5945_ot4gat.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540843/IMG_5954_qxtyro.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540844/IMG_5959_l4ibig.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540845/IMG_5962_aes3kq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540845/IMG_5953_ya4ssr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540849/IMG_5980_qjujre.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540849/IMG_5969_zcwvpg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540850/IMG_5976_q9fsnj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540850/IMG_5997_gohwsi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540850/IMG_5992_mrbyoq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540852/IMG_5999_uy9j5k.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540854/IMG_6006_tfglo0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749540854/IMG_6004_y3furb.jpg',
   
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749540832/COVER_urynqk.jpg',
  issue: '18',
},


'shoot33': {
  title: 'FAST LANE',
  date: 'September 2022',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541550/COVER_i0mix1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541551/IMG_9454_ojtxqc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541551/IMG_9460_p46l0j.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541553/IMG_9478_ocousb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541554/IMG_9479_nov0l0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541555/IMG_9499_h6pbzg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541556/IMG_9570_yomj8y.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541558/IMG_9585_g90ph1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541559/IMG_9594_ybuuwq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541560/IMG_9604_ichple.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541562/IMG_9624_qy2gpm.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541563/IMG_9632_d0os1r.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541564/IMG_9633_muncgj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541566/IMG_9644_ukeqnx.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749541550/COVER_i0mix1.jpg',
  issue: '14',
},

'shoot34': {
  title: 'EYES ON THE ROAD',
  date: 'December 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541752/COVER_tnccy1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541753/IMG_3926_anj22q.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541755/OFFICAL_PART_2_temoeu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541757/IMG_3719_pt46n1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541758/IMG_3659_yvvjec.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541760/IMG_3648_i5xdre.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541762/IMG_2035-Enhanced-NR_gzdpth.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541763/IMG_2385-Enhanced-NR_1_ihvdyh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541768/IMG_2837-Enhanced-NR_uq3453.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541768/IMG_2138-Enhanced-NR_ffyshh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541769/IMG_2131-Enhanced-NR_tpmu8s.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541771/IMG_2563-Enhanced-NR_xdgdyr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541773/IMG_2403-Enhanced-NR_jguj4b.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541774/IMG_2033-Enhanced-NR_iuuqsq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541776/IMG_2235-Enhanced-NR_jzdapb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541778/IMG_2229-Enhanced-NR_m74cu2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541779/IMG_1905-Enhanced-NR_hg0xpk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541780/IMG_2069-Enhanced-NR_tvwusm.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541782/IMG_1876-Enhanced-NR_bngufy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541784/IMG_2527-Enhanced-NR_ejgcz0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541785/IMG_2697-Enhanced-NR_irrfrj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541787/IMG_1937-Enhanced-NR_tsvlrt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541789/IMG_1900-Enhanced-NR_ehjbrp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541792/IMG_2021-Enhanced-NR_bbrear.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541793/IMG_2753-Enhanced-NR_gpcxy5.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541794/IMG_2741-Enhanced-NR_x8f11r.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541796/IMG_2316-Enhanced-NR_rnkz6h.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541798/IMG_1897-Enhanced-NR_gixndr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541801/IMG_2447-Enhanced-NR_uxhi4d.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541801/IMG_2806-Enhanced-NR_qglrsh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541802/IMG_2253-Enhanced-NR_gpdrjl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541804/IMG_2713-Enhanced-NR_s4lfdu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541807/IMG_2649-Enhanced-NR_popbyr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541822/IMG_2514-Enhanced-NR_jowtah.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541823/IMG_2586-Enhanced-NR_d9daj3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541824/IMG_2365-Enhanced-NR_v6kku8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541826/IMG_2220-Enhanced-NR_z2znxp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541828/IMG_2476-Enhanced-NR_me55dz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541829/IMG_2472-Enhanced-NR_ji1dzl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541831/IMG_2453-Enhanced-NR_zprham.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749541832/IMG_2224-Enhanced-NR_d6kmwm.jpg',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749541753/FIRST_3_yb4tn5.mp4',
    '../Assets/Large-Content/video15.mp4',
    '../Assets/Large-Content/video16.mp4',
   
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749541752/COVER_tnccy1.jpg',
  issue: '24',
},

'shoot35': {
  title: 'DOUBLE TAKE',
  date: 'December 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749542757/COVER_f62dho.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543172/IMG_1732-Enhanced-NR_f0o68k.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543152/IMG_1594-Enhanced-NR_qag4ik.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543150/IMG_1560-Enhanced-NR_fkpaff.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543147/IMG_1444-Enhanced-NR_mkc5uq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543145/IMG_1412-Enhanced-NR_ki2ajx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543142/IMG_1788-Enhanced-NR_wbp4nk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543140/IMG_1675-Enhanced-NR_j5tque.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543137/IMG_1683-Enhanced-NR_hfmwun.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543135/IMG_1667-Enhanced-NR_siuhdk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543133/IMG_1499-Enhanced-NR_mmn05p.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543130/IMG_1657-Enhanced-NR_ugilwz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543129/IMG_1627-Enhanced-NR_t1j5oa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543126/IMG_1473-Enhanced-NR_kkrgzw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543123/IMG_1548-Enhanced-NR_bj8y2s.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543122/IMG_1543-Enhanced-NR_fkvjlx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749542787/IMG_1414-Enhanced-NR_ykoxm1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749542775/IMG_1422-Enhanced-NR_kgolhs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749542772/IMG_1515-Enhanced-NR_tu0tzt.jpg',
    '../Assets/Large-Content/video16.mp4',
   
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749542757/COVER_f62dho.jpg',
  issue: '20',
},

'shoot36': {
  title: 'DEEP INTO THE GARDENS',
  date: 'November 2022',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543646/COVER_ubwyar.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543653/IMG_5310_dz6del.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543655/IMG_5266_pmmyn6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543655/IMG_5289_psrtqh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543660/IMG_5273_qbm6i7.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543660/IMG_5272_rh49xo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543665/IMG_5315_hrr1sg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543665/IMG_5275_fixven.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543687/IMG_5323_gg3dwr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543688/IMG_5335_okzc7c.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543689/IMG_5383_cxfn5k.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543689/IMG_5327_hhlgfq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543689/IMG_5277_gwzvxa.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543690/IMG_5280_csrbog.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543690/IMG_5384_bwtqn3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543690/IMG_5394_jzp5xg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543690/IMG_5326_f91o6e.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543690/IMG_5324_p8ysrv.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543693/IMG_5408_pn6mgc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749543692/IMG_5312_rd90bi.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749543646/COVER_ubwyar.jpg',
  issue: '15',
},

'shoot37': {
  title: 'CROSSING IN CONTRAST',
  date: 'April 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544299/COVER_moc4tg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544301/IMG_2801_mi0qxz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544304/IMG_2813_dnsbuu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544306/IMG_2817_ho7hkl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544310/IMG_2912_xtzezo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544313/IMG_2933_j2gv2p.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544315/IMG_2938_tomcwz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544319/IMG_2959_xt2cb8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544322/IMG_3032_mld13v.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544324/IMG_2720_p6z0zs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544327/IMG_2734_kq0ixd.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544330/IMG_2738_a02qig.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544333/IMG_2742_ghjeh9.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544336/IMG_2917_liyzoq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544338/IMG_2955_b0urxe.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544341/IMG_2999_uixmbe.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544344/IMG_3022_b96eet.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544347/IMG_3024_alkpfj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544350/IMG_3038_qznvxh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544353/IMG_3042_exhcah.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544356/IMG_3083_o9oh6e.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544359/IMG_3110_c7ptqy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544362/IMG_3107_ponczy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544365/IMG_3133_jtxgu1.jpg',
    '../Assets/Large-Content/video18.mp4',
   
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749544299/COVER_moc4tg.jpg',
  issue: '21',
},

'shoot38': {
  title: 'CONCRETE DREAMS',
  date: 'April 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544754/Yes_-5_fg2ctz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544754/IMG_9537_yrltxu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544751/IMG_9073_1_co4rip.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544751/IMG_9117_1_bev80m.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544750/IMG_9222_1_miotpw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544749/IMG_9193_1_rjwljj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544748/IMG_9246_1_lubibp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544747/IMG_9254_1_lnmmub.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544746/IMG_9260_1_vy0lj6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544746/IMG_9253_1_j5j2xz.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749544754/Yes_-5_fg2ctz.jpg',
  issue: '2',
},

'shoot39': {
  title: 'COFFEE RUN',
  date: 'WINTER 2025',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544956/COVER_qyuoix.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544950/IMG_4832_hlkqca.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544951/IMG_4817_r16qxt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544951/IMG_4807_zubnnu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544953/IMG_4768_hr9wek.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544956/DSC_0755_sodwol.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544956/IMG_3853_xywsbl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544959/DSC_0635_voqilr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544960/DSC_0331_xjvnfb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544963/DSC_0259_zs15kp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544963/DSC_0277_napnhy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544963/DSC_0286_g4za1c.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544966/DSC_0294_wx0thg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544966/DSC_0394_ftocyw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544967/DSC_0418_jsoswf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544968/DSC_0258_ef60yl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544970/DSC_0207_s6sbkl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544970/DSC_0553_bk99ar.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544973/DSC_0531-2_quvnsm.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544973/DSC_0472_vgvrdx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544974/DSC_0519_nkox9r.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544975/DSC_0425_rutsuj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544971/DSC_0442_dw6ohk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544976/DSC_0599_n86vgb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544980/P1050339_y3aqhw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544981/DSC_0430_mithzp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544982/DSC_0771_luc1sv.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544984/DSC_0822_oztasd.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544986/DSC_0702_fnwmfc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749544987/P1050302_m0gzu0.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749544956/COVER_qyuoix.jpg',
  issue: '25',
},


'shoot40': {
  title: 'CLASS OF 2023',
  date: 'April 2023',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545426/COVER_namrh1.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545428/IMG_8584-Edit_yzn8jw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545429/IMG_8505-Edit_aanvmr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545430/IMG_8471-Edit-2_dewiea.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545430/IMG_8376-Edit_gfwxcw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545432/IMG_8370-Edit_ocrtot.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545434/IMG_8353-Edit_brgocp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545436/IMG_8331-Edit_djdvwu.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749545426/COVER_namrh1.jpg',
  issue: '17',
},


'shoot41': {
  title: 'CALIFORNIA GIRLS',
  date: 'June 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545683/COVER_2_hx0zrr.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545684/IMG_8594_eyxxar.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545685/IMG_6682_tpkma4.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545687/IMG_7860_zs7v4l.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545688/IMG_7863_bhwauc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545690/IMG_6681_yx99az.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545691/PenultimateFullSizeRender_xmxfkj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545694/IMG_6117_odi0k2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545694/IMG_6008_rmzz8a.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545696/IMG_6166_evfo1w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545698/IMG_5895_kvyll7.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545700/IMG_6167_ahfeex.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545701/IMG_6059_iw8yyg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545702/IMG_7857_a0mvdk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545704/PenultimateFullSizeRender_1_owetxz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545706/PenultimateFullSizeRender_3_cqhhrl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545708/PenultimateFullSizeRender_2_p20whj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545709/PenultimateFullSizeRender_4_efq4d9.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749545710/PenultimateFullSizeRender_6_w14inh.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749545683/COVER_2_hx0zrr.jpg',
  issue: '4',
},


'shoot42': {
  title: 'BOLLYWOOD TO HOLLYWOOD',
  date: 'April 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546303/COVER_rsneyk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546305/IMG_3900_ub4mrh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546304/IMG_3870_s7hsaz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546306/IMG_3875_ofkblt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546308/IMG_3913_aecfuj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546310/IMG_3907_vi0rax.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546312/IMG_3933_sysd2y.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546315/IMG_4068_mjb73w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546316/IMG_4096_okkzmh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546318/IMG_4139_jdux6q.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546320/IMG_4143_upfoae.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546322/IMG_4150_ggsi2d.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546323/IMG_4275_entrbf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546325/IMG_4278_xw073w.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546327/IMG_4282_rotu2x.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546329/IMG_4320_j5nvzg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546329/IMG_4320_j5nvzg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546331/IMG_4306_xkabev.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546333/IMG_4374_v46ku3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546334/IMG_4435_nu90hb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546337/IMG_4380_e4n4ft.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749546339/IMG_4289_xuocru.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749546303/COVER_rsneyk.jpg',
  issue: '21',
},


'shoot43': {
  title: 'BOLLYWOOD BARBIES',
  date: 'June 2023',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547183/COVER_gl0noi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547262/IMG_2315_cx9suv.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547260/IMG_2295_yfboj7.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547258/IMG_2262_cuugec.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547256/IMG_2239_h9m14l.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547254/IMG_2221_qvo6w0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547251/IMG_2194_ueio7u.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547249/IMG_2172_pfw96a.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547247/IMG_2156_gm0ind.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547244/IMG_2122_vwr1sk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547243/IMG_2120_efbodu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547240/IMG_2092_pb7kwt.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547238/IMG_2085_uc4i78.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547236/IMG_2078_dpmtnj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547234/IMG_2072_bpanlx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547232/IMG_2038_mz6mf9.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547229/IMG_2024_ixvwwl.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547226/IMG_1974_rspiud.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547225/IMG_1955_fypuhk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547223/IMG_1949_py3kc8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547220/IMG_1947_ctnyvn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547218/IMG_1937_jijnng.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547216/IMG_1926_e7vi1m.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547213/IMG_1894_xbyqlz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547211/IMG_1845_wwmyhc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547209/IMG_1776_iwws6i.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547207/IMG_1775_mojxj2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547205/IMG_1759_au43a2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547203/IMG_1749_fzvty5.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547201/IMG_1745_heno1n.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547199/IMG_1744_qxcd7s.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547197/IMG_1729_ufhray.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547195/IMG_1724_yo0kmn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547192/IMG_1719_qvyehk.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547191/IMG_1716_akviph.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547189/IMG_1709_zuexvc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547187/IMG_1663_wpqz5o.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547184/IMG_1627_xftimq.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547180/IMG_2438_m1fhrf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547178/IMG_2433_hnwgvj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547177/IMG_2427_raekfo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547175/IMG_2420_ehlqhy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547173/IMG_2397_wldoa5.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547171/IMG_2393_it2s6z.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547169/IMG_2367_pbm4ed.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547167/IMG_2343_spldr8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547162/IMG_2363_llcuth.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547161/IMG_2360_zctjtb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547159/IMG_2354_ygb3qb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547157/IMG_2349_li1rfi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547265/IMG_2338_zmoxnl.jpg'
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749547183/COVER_gl0noi.jpg',
  issue: '18',
},

'shoot44': {
  title: 'A TOUCH OF CLASS',
  date: 'July 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548007/COVER_ne08ax.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548019/IMG_2122_muk1rv.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548017/IMG_2091_gmxmfz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548014/IMG_2103_ayuccy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548012/IMG_2109_h7cyxs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548010/IMG_2181_uvbfkp.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548005/IMG_1486_wuvfo6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548000/IMG_1719_c4oayc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547998/IMG_1726_ejhwfh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547996/IMG_1783_en5uky.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547993/IMG_1773_fzkvpz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547991/IMG_1791_dfwdew.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547989/IMG_1800_g88ffo.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547987/IMG_1833_f3y4dh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547982/IMG_1873_oxhdv7.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547980/IMG_1882_fvavaj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547978/IMG_1887_dcjt0l.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547975/IMG_1892_dp4l35.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547973/IMG_1944_umjrct.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547971/IMG_1951_yzege3.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547969/IMG_1954_kendb6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547963/IMG_1963_xtlgrs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547961/IMG_1967_eoeadu.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547960/IMG_1996_kbcthw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749547958/IMG_2080_tuj4hs.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749548007/COVER_ne08ax.jpg',
  issue: '5',
},

'shoot45': {
  title: 'BIKERS VS SURFERS',
  date: 'July 2024',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548206/COVER_rjvpjy.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548204/IMG_2493_pwhca8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548211/IMG_4305_l9np01.jpg',
    'https://res.cloudinary.com/dltjxocio/video/upload/v1749548211/Final_export_08-31_ii7cl0.mp4',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548213/IMG_4303_rcovws.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548216/IMG_4297_wdgyvg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548219/IMG_4281_kvpd2l.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548221/IMG_4269_maxgf6.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548223/IMG_4264_ayckx2.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548226/IMG_4259_afthda.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548228/IMG_4240_gfgbdi.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548230/IMG_4219_ptbs7t.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548233/IMG_4209_sivzwx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548235/IMG_4050_w7evyw.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548239/IMG_4027_yirvxf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548240/IMG_4024_rnm6hs.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548243/IMG_4009_nvmvk0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548246/IMG_3980_vj9qpe.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548248/IMG_3977_rak15z.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548251/IMG_3962_ckcqdg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548253/IMG_3957_bkkxxc.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548260/IMG_3939_g27wge.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548262/IMG_3938_hmlssf.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548265/IMG_3877_vqadb0.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548270/IMG_3867_bamz5v.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548267/IMG_3876_qoesrb.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749548206/COVER_rjvpjy.jpg',
  issue: '22',
},


'shoot46': {
  title: 'ABOVE THE ORDINARY',
  date: 'June 2021',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548538/COVER_psr095.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548538/IMG_5745_zs9om8.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548539/IMG_7542_kpyknx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548539/IMG_7544_twmfyg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548539/IMG_7543_juykko.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548539/IMG_8247_Original_rckals.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548540/IMG_7531_pnq4hh.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548540/IMG_7424_zuvxhz.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548540/IMG_7538_z4x01y.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548541/IMG_7537_ppfgux.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548541/IMG_7539_acnmyg.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548541/IMG_7532_dosgfn.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548542/IMG_7535_avi2or.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548542/IMG_7536_xbmzzs.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749548538/COVER_psr095.jpg',
  issue: '4',
},

'shoot47': {
  title: '3-IN-1 WITH PEARLESCENT X REYA',
  date: 'October 2023',
  description: '',
  images: [
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548705/COVER_gbrews.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548707/IMG_4155-Edit_xaj6vx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548747/IMG_4257-Edit_cejpax.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548755/IMG_4244-Edit_s3y4ks.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548765/IMG_4231-Edit_zzeqzb.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548825/IMG_4203-Edit_osbm6k.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548906/IMG_4214_novwvx.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548906/IMG_4117_w8kmsj.jpg',
    'https://res.cloudinary.com/dltjxocio/image/upload/v1749548907/IMG_3592_agaad2.jpg',
  ],
  thumbnail: 'https://res.cloudinary.com/dltjxocio/image/upload/v1749548705/COVER_gbrews.jpg',
  issue: '19',
},








};


const Media = () => {
    const [openMediaKey, setOpenMediaKey] = useState(null);

    // prepare array for EmbeddedContent
    const items = Object.entries(mediaData).map(([id, { title, issue, thumbnail }]) => ({
        id,
        title,
        issue,
        thumbnail,
    }));

    return(
        <div className="media-page">
            <div className="video-text-container">
            <video autoPlay loop muted playsInline>
                <source src="../Assets/Media/text-video.mp4" type="video/mp4" />
            </video>
            <div className="text-box-media">
                <h1 className="media-header-text">MEDIA</h1>
            </div>
            </div>
            <div className="media-info-container">
                <div className="media-info-title">
                    our creative evolution
                </div>
                <div className="media-paragraph-text">
                    At <i>solucky</i>, our team's creativity shines through captivating editorial content.
                    Every few months, we release a magazine issue featuring three to four main photoshoots,
                    showcasing artistic flair & countless hours of dedication to an eccentric theme. From 
                    our early days to now, our media reflects a growing community driven by collaboration,
                    creativity, & storytelling. Explore photos, videos, & highlights from our magazine issues,
                    events, & collaborations, capturing the evolution of our brand.
                </div>
            </div>

           <div className="macbook-interact-container">
                <div className="interact-text-wrapper">
                    <img className="media-arrow-svg" src="../Assets/Media/interact-text-arrow.svg" alt="" />
                </div>

                <div className="macbook-image-wrapper">
                    <img className="macbook-image" src="../Assets/Media/macbook.svg" alt="" />
                    <div className="laptop-screen-frame">
                        <div className="embedded-frame-wrapper">
                            <EmbeddedContent items={items} onSelect={setOpenMediaKey} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="small-screen-interact-container">
                <div className="alt-interact-text-wrapper">
                    <img className="alt-media-arrow-svg" src="../Assets/Media/alt-interact-text-arrow.svg" />
                </div>
                
                {items.map(({ id, title, issue, thumbnail }) => (
                    <div
                        key={id}
                        className="small-screen-card"
                        onClick={() => setOpenMediaKey(id)}
                        style={{ cursor: 'pointer' }}
                    >
                        <img
                        src={thumbnail}
                        alt={title}
                        className="small-screen-thumb"
                        />
                        <div className="small-screen-text-container">
                            <div className="small-screen-title">{title}</div>
                            <div className="small-screen-issue">Issue {issue}</div>                            
                        </div>
                    </div>
                ))}
            </div>

            {openMediaKey && (
                <Gallery
                title={mediaData[openMediaKey].title}
                date={mediaData[openMediaKey].date}
                description={mediaData[openMediaKey].description}
                images={mediaData[openMediaKey].images}
                onClose={() => setOpenMediaKey(null)}
                />
            )}
            <Footer/>
        </div>
    )
}

export default Media